import { render, staticRenderFns } from "./dropdown_item.vue?vue&type=template&id=73c5ace6"
import script from "./dropdown_item.vue?vue&type=script&lang=js"
export * from "./dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports